import React from "react";
import { Upload } from "antd";

function UploadFile({
  handleUpload,
  handleImageBeforeUpload,
  width,
  height,
  shadow = true,
  textSize,
  fileSize,
  name,
  children,
}) {
  return (
    <div>
      <Upload
        multiple={true}
        customRequest={(item) => handleUpload(item, name)}
        beforeUpload={(file) => handleImageBeforeUpload(file, fileSize)}
        showUploadList={false}
        accept=".png,.jpg,.jpeg,.svg" // Updated file types
        className="w-[100%]"
      >
        {children}
      </Upload>
    </div>
  );
}

export default UploadFile;
